import React from "react";
import { IconProps } from "../../../lib/types";

const GatewayJobsIcon: React.FC<IconProps> = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      tabIndex={onClick ? 0 : -1}
      xmlns="http://www.w3.org/2000/svg"
      width="19.207"
      height="17.073"
      viewBox="0 0 19.207 17.073"
    >
      Ï
      <path
        d="M9.07 1.657v13.815H3.735V3.094zm1.6 13.815V1.414A1.415 1.415 0 009.257 0a1.37 1.37 0 00-.367.05l-5.572 1.5a1.606 1.606 0 00-1.184 1.544v12.378H.8a.8.8 0 100 1.6h9.87zM7.469 9.6c.44 0 .8-.48.8-1.067s-.36-1.067-.8-1.067-.8.48-.8 1.067.357 1.067.8 1.067zm4.268-5.869h3.468a.268.268 0 01.267.269v12.272a.8.8 0 00.8.8h2.134a.8.8 0 000-1.6h-1.333V4a1.869 1.869 0 00-1.867-1.867h-3.468z"
        className="a"
      ></path>
    </svg>
  );
}

export default GatewayJobsIcon;
